import React from "react";
import PropTypes from "prop-types";
import InputGroupButtonDropdown from "reactstrap/lib/InputGroupButtonDropdown";
import DropdownToggle from "reactstrap/lib/DropdownToggle";
import DropdownMenu from "reactstrap/lib/DropdownMenu";
import DropdownItem from "reactstrap/lib/DropdownItem";
import ChevronDefaultRight from "@druva-apps/orion-icons/lib/ChevronsmallrightGreyOutline";
import { MERIDIEM_AM, MERIDIEM_PM } from "../../lib/timePickerUtils";

class Meridiem extends React.Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  /**
   * Toggle meridiem dropdown open|close
   */
  toggle = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  };

  render() {
    const { isOpen } = this.state;
    const { value, onChange, disabled } = this.props;
    return (
      <InputGroupButtonDropdown
        addonType="append"
        toggle={this.toggle}
        isOpen={isOpen}
        className="oui-timepicker-meridiem"
      >
        <DropdownToggle className="oui-meridiem-toggle" disabled={disabled}>
          {value}&nbsp;
          <div className="oui-dropdown-caret">
            <ChevronDefaultRight inheritFontColor />
          </div>
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem onClick={() => onChange(MERIDIEM_AM)}>
            {MERIDIEM_AM}
          </DropdownItem>
          <DropdownItem onClick={() => onChange(MERIDIEM_PM)}>
            {MERIDIEM_PM}
          </DropdownItem>
        </DropdownMenu>
      </InputGroupButtonDropdown>
    );
  }
}

Meridiem.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};

export default Meridiem;
